/* ============================================================
   HumSafer — interactions & motion
   ============================================================ */
(function(){
  'use strict';
  document.getElementById('yr').textContent = new Date().getFullYear();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce) document.documentElement.classList.add('js-anim');
  if(!document.documentElement.dataset.motion) document.documentElement.dataset.motion = reduce ? 'subtle' : 'rich';
  function motionRich(){ return document.documentElement.dataset.motion === 'rich'; }

  /* ---- in-view engine (scroll-based; works even in offscreen iframes) ---- */
  var oneShots = [];
  function inView(el, margin){ var r = el.getBoundingClientRect(); return r.top < (window.innerHeight - (margin||40)) && r.bottom > 0; }
  function checkAll(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ if(inView(el)) el.classList.add('in'); });
    for(var i=oneShots.length-1;i>=0;i--){ if(inView(oneShots[i].el, oneShots[i].m)){ oneShots[i].fn(); oneShots.splice(i,1); } }
  }
  window.addEventListener('scroll', checkAll, {passive:true});
  window.addEventListener('resize', checkAll, {passive:true});
  window.addEventListener('load', checkAll);

  /* ---- sticky header shade ---- */
  var header = document.getElementById('siteHeader');
  function onScroll(){ header.classList.toggle('scrolled', window.scrollY > 20); }
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  /* ---- mobile nav ---- */
  var menuBtn = document.getElementById('menuBtn'), nav = document.getElementById('primaryNav');
  menuBtn.addEventListener('click', function(){
    var open = nav.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', open);
  });
  nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ nav.classList.remove('open'); }); });

  /* ---- scroll reveal ---- */
  checkAll();

  /* ---- demo modal ---- */
  var modal = document.getElementById('demoModal'), modalClose = document.getElementById('modalClose');
  function openModal(){ modal.classList.add('open'); document.body.style.overflow='hidden'; setTimeout(function(){ var f=document.getElementById('mn'); if(f) f.focus(); },120); }
  function closeModal(){ modal.classList.remove('open'); document.body.style.overflow=''; }
  document.querySelectorAll('[data-demo]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openModal(); }); });
  modalClose.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e){ if(e.target===modal) closeModal(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && modal.classList.contains('open')) closeModal(); });

  /* ---- forms: the demo modal now submits for real via Shopify's contact form.
         The old fake "show thank-you" interception has been removed. ---- */

  /* ---- hero live speed: ticks safe, occasionally spikes over 65 into a red alarm ---- */
  var speedEl = document.getElementById('liveSpeed');
  var speedChip = document.querySelector('.chip-speed');
  if(speedEl && speedChip && !reduce){
    var s = 52, over = false;
    setInterval(function(){
      if(!motionRich()) return;
      if(over){
        s += (Math.random()*6 - 2); s = Math.max(66, Math.min(82, s));
        speedEl.textContent = Math.round(s);
      } else if(Math.random() < 0.2){
        over = true;
        s = 67 + Math.random()*9;
        speedEl.textContent = Math.round(s);
        speedChip.classList.add('alarm');
        setTimeout(function(){
          over = false;
          s = 53 + Math.random()*6;
          speedEl.textContent = Math.round(s);
          speedChip.classList.remove('alarm');
        }, 3600);
      } else {
        s += (Math.random()*6 - 3); s = Math.max(46, Math.min(63, s));
        speedEl.textContent = Math.round(s);
      }
    }, 1400);
  }

  /* ---- how-it-works step visuals (lightweight SVG) ---- */
  var stepVis = {
    phone:'<svg viewBox="0 0 120 120" width="100%" height="100%"><rect x="44" y="22" width="32" height="60" rx="6" fill="#1A1A1A"/><rect x="48" y="28" width="24" height="44" rx="3" fill="#1F7A1F"/><circle cx="60" cy="50" r="9" fill="#fff"/><circle cx="60" cy="92" r="3" fill="#ED731D"><animate attributeName="r" values="3;5;3" dur="1.6s" repeatCount="indefinite"/></circle></svg>',
    alert:'<svg viewBox="0 0 120 120" width="100%" height="100%"><circle cx="60" cy="60" r="30" fill="none" stroke="#ED731D" stroke-width="3" opacity=".3"/><circle cx="60" cy="60" r="30" fill="none" stroke="#ED731D" stroke-width="3" stroke-dasharray="188" stroke-dashoffset="120"><animateTransform attributeName="transform" type="rotate" from="0 60 60" to="360 60 60" dur="3s" repeatCount="indefinite"/></circle><path d="M52 54a8 8 0 0 1 16 0c0 6-8 6-8 12" fill="none" stroke="#ED731D" stroke-width="3.5" stroke-linecap="round"/><circle cx="60" cy="76" r="2.4" fill="#ED731D"/></svg>',
    dash:'<svg viewBox="0 0 120 120" width="100%" height="100%"><rect x="30" y="38" width="60" height="44" rx="5" fill="#fff" stroke="#E7E1DA" stroke-width="2"/><path d="M36 70l10-10 8 6 12-16 10 8" fill="none" stroke="#1F7A1F" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="36" y="44" width="20" height="3" rx="1.5" fill="#ED731D"/><circle cx="74" cy="52" r="3" fill="#ED731D"><animate attributeName="opacity" values="1;.3;1" dur="1.5s" repeatCount="indefinite"/></circle></svg>'
  };
  document.querySelectorAll('.step-visual').forEach(function(el){ var k=el.getAttribute('data-step'); if(stepVis[k]) el.innerHTML=stepVis[k]; });

  /* ---- moving truck pins on the map ---- */
  var mapWrap = document.getElementById('mapWrap');
  if(mapWrap){
    var svgEl = mapWrap.querySelector('svg');
    var paths = [svgEl.getElementById('route1'), svgEl.getElementById('route2')];
    var truckSVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1"/><path d="M14 9h4l3 3v5h-7z"/></svg>';
    var trucks=[];
    function vb(){ return {w:600,h:330}; }
    [{p:0,t:0.1,g:false},{p:0,t:0.55,g:true},{p:0,t:0.85,g:false},{p:1,t:0.25,g:true},{p:1,t:0.6,g:false},{p:1,t:0.92,g:true}].forEach(function(cfg,i){
      var pin=document.createElement('div'); pin.className='truck-pin'+(cfg.g?' green':''); pin.innerHTML=truckSVG;
      mapWrap.appendChild(pin);
      trucks.push({el:pin, path:paths[cfg.p], t:cfg.t, speed:0.00006+Math.random()*0.00006});
    });
    function place(){
      var rect=mapWrap.getBoundingClientRect(); var V=vb();
      trucks.forEach(function(tr){
        var L=tr.path.getTotalLength(); var pt=tr.path.getPointAtLength(tr.t*L);
        tr.el.style.left=(pt.x/V.w*rect.width)+'px';
        tr.el.style.top=(pt.y/V.h*rect.height)+'px';
      });
    }
    var last=null;
    function tick(ts){
      if(last==null) last=ts; var dt=ts-last; last=ts;
      if(motionRich()){ trucks.forEach(function(tr){ tr.t+=tr.speed*dt; if(tr.t>1) tr.t-=1; }); }
      place(); requestAnimationFrame(tick);
    }
    place();
    requestAnimationFrame(tick);
    window.addEventListener('resize', place, {passive:true});
  }

  /* ---- fatigue heatmap (illustrative, deterministic) ---- */
  var heat = document.getElementById('heat');
  var heatColors=['#E7F1E7','#FDE3CC','#F6B173','#ED731D','#B8470A'];
  var days=['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  var labels=['12–4 AM','4–8 AM','8 AM–12 PM','12–4 PM','4–8 PM','8 PM–12 AM'];
  // higher risk in 12-4am (0), 8pm-12 (5) and end-of-week
  var base=[4,1,0,1,2,3];
  if(heat){
    var tip=document.createElement('div'); tip.className='heat-tip'; document.body.appendChild(tip);
    var cells=[];
    days.forEach(function(d,r){
      var rh=document.createElement('div'); rh.className='row-h'; rh.textContent=d; heat.appendChild(rh);
      for(var c=0;c<6;c++){
        var lvl=base[c] + (r>=4? 1:0) - (c===2||c===3?1:0);
        // small deterministic jitter
        lvl += ((r*7+c*3)%3===0)?1:0;
        lvl=Math.max(0,Math.min(4,lvl));
        var cell=document.createElement('div'); cell.className='cell';
        cell.dataset.lvl=lvl; cell.dataset.day=d; cell.dataset.win=labels[c];
        cell.style.background=heatColors[lvl];
        heat.appendChild(cell); cells.push(cell);
      }
    });
    // animate in on view
    oneShots.push({el:heat, m:30, fn:function(){
      cells.forEach(function(cell,i){ setTimeout(function(){ cell.style.transform='scale(1)'; }, reduce?0:i*14); });
    }});
    // tooltips
    var risk=['Low','Guarded','Moderate','Elevated','High'];
    cells.forEach(function(cell){
      cell.addEventListener('mouseenter', function(){
        tip.innerHTML=cell.dataset.day+' · '+cell.dataset.win+'<small>'+risk[cell.dataset.lvl]+' fatigue risk</small>';
        tip.classList.add('on');
      });
      cell.addEventListener('mousemove', function(e){ tip.style.left=(e.clientX+14)+'px'; tip.style.top=(e.clientY-10)+'px'; });
      cell.addEventListener('mouseleave', function(){ tip.classList.remove('on'); });
    });
  }

  /* ---- safety vs workload chart ---- */
  var chart=document.getElementById('chart');
  if(chart){
    var W=400,H=230,pad=10;
    var safety=[88,90,85,82,80,84,78,82]; // 0-100
    var km=[2100,2600,3000,3400,3700,3200,3900,3500]; // weekly km
    var kmMax=4200;
    function x(i){ return pad + i*((W-2*pad)/(safety.length-1)); }
    function ySafe(v){ return H-pad - (v/100)*(H-2*pad); }
    function yKm(v){ return H-pad - (v/kmMax)*(H-2*pad); }
    function line(arr,fn){ return arr.map(function(v,i){ return (i?'L':'M')+x(i).toFixed(1)+','+fn(v).toFixed(1); }).join(' '); }
    var ns='http://www.w3.org/2000/svg';
    // grid
    for(var g=0;g<=3;g++){
      var gy=pad+g*((H-2*pad)/3);
      var ln=document.createElementNS(ns,'line'); ln.setAttribute('x1',pad);ln.setAttribute('x2',W-pad);ln.setAttribute('y1',gy);ln.setAttribute('y2',gy);
      ln.setAttribute('stroke','#E7E1DA');ln.setAttribute('stroke-width','1'); chart.appendChild(ln);
    }
    // km area
    var area=document.createElementNS(ns,'path');
    area.setAttribute('d', line(km,yKm)+' L'+x(km.length-1)+','+(H-pad)+' L'+x(0)+','+(H-pad)+' Z');
    area.setAttribute('fill','rgba(237,115,29,.10)'); chart.appendChild(area);
    var kmLine=document.createElementNS(ns,'path');
    kmLine.setAttribute('d',line(km,yKm)); kmLine.setAttribute('fill','none');
    kmLine.setAttribute('stroke','#ED731D'); kmLine.setAttribute('stroke-width','2.5'); kmLine.setAttribute('stroke-linecap','round'); kmLine.setAttribute('stroke-linejoin','round');
    chart.appendChild(kmLine);
    var safeLine=document.createElementNS(ns,'path');
    safeLine.setAttribute('d',line(safety,ySafe)); safeLine.setAttribute('fill','none');
    safeLine.setAttribute('stroke','#1F7A1F'); safeLine.setAttribute('stroke-width','2.5'); safeLine.setAttribute('stroke-linecap','round'); safeLine.setAttribute('stroke-linejoin','round');
    chart.appendChild(safeLine);
    // dots on safety
    safety.forEach(function(v,i){ var d=document.createElementNS(ns,'circle'); d.setAttribute('cx',x(i));d.setAttribute('cy',ySafe(v));d.setAttribute('r','3.2');d.setAttribute('fill','#fff');d.setAttribute('stroke','#1F7A1F');d.setAttribute('stroke-width','2'); chart.appendChild(d); });
    // animate draw
    if(!reduce){
      [kmLine,safeLine].forEach(function(p){ var len=p.getTotalLength(); p.style.strokeDasharray=len; p.style.strokeDashoffset=len; });
      oneShots.push({el:chart, m:40, fn:function(){
        [kmLine,safeLine].forEach(function(p){ p.style.transition='stroke-dashoffset 1.4s ease'; p.style.strokeDashoffset=0; });
      }});
    }
  }
  checkAll();
})();


(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rich(){ return document.documentElement.dataset.motion === 'rich'; }

  /* driver Drive-Mode speedometer */
  var sp = document.getElementById('hwSpeed'), arc = document.getElementById('hwArc');
  function setArc(v){ if(arc){ var frac = Math.max(0, Math.min(1, v/120)); arc.setAttribute('stroke-dasharray', (frac*377).toFixed(1)+' 503'); } }
  if(sp){
    var s = 52; setArc(s);
    if(!reduce) setInterval(function(){ if(!rich()) return; s += Math.random()*8-4; s = Math.max(44, Math.min(64, s)); var r = Math.round(s); sp.textContent = r; setArc(r); }, 1500);
  }

  /* dashboard KPI tickers */
  function kpi(id, lo, hi, suffix, rare){
    var el = document.getElementById(id); if(!el || reduce) return;
    var span = hi - lo;
    setInterval(function(){
      if(!rich()) return;
      if(rare && Math.random() > 0.4) return;
      var n = lo + Math.round(Math.random()*span);
      el.textContent = n + (suffix||'');
    }, rare ? 2600 : 1800);
  }
  kpi('kpiTrucks', 45, 52, '', false);
  kpi('kpiAlerts', 10, 16, '', true);
  kpi('kpiOnTime', 92, 96, '%', false);

  /* dashboard truck moving along the route */
  var map = document.getElementById('hwMap');
  if(map){
    var path = document.getElementById('hwRoute');
    var pin = document.createElement('div'); pin.className = 'tpin';
    pin.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1"/><path d="M14 9h4l3 3v5h-7z"/></svg>';
    map.appendChild(pin);
    var t = 0.12, last = null, V = {w:600, h:168};
    function place(){ var rect = map.getBoundingClientRect(); var L = path.getTotalLength(); var p = path.getPointAtLength(t*L);
      pin.style.left = (p.x/V.w*rect.width)+'px'; pin.style.top = (p.y/V.h*rect.height)+'px'; }
    function loop(ts){ if(last==null) last = ts; var dt = ts-last; last = ts; if(rich()){ t += 0.00007*dt; if(t>1) t -= 1; } place(); requestAnimationFrame(loop); }
    place(); requestAnimationFrame(loop);
    window.addEventListener('resize', place, {passive:true});
  }

  /* BBC video — click thumbnail to load YouTube embed */
  var bbc = document.getElementById('bbcPlayer');
  if(bbc){
    function playBBC(){
      var id = bbc.getAttribute('data-yt');
      if(!id || bbc.dataset.playing) return;
      bbc.dataset.playing = '1';
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'HumSafer featured on BBC News';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      bbc.innerHTML = '';
      bbc.appendChild(f);
      bbc.style.cursor = 'default';
    }
    bbc.addEventListener('click', playBBC);
    bbc.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); playBBC(); } });
  }

  /* app screenshot slideshows — cycle every 2s */
  document.querySelectorAll('[data-shots]').forEach(function(box){
    var shots = box.querySelectorAll('.app-shot');
    if(shots.length < 2) return;
    var i = 0;
    setInterval(function(){
      shots[i].classList.remove('is-active');
      i = (i + 1) % shots.length;
      shots[i].classList.add('is-active');
    }, 3000);
  });
})();
